// Vibración corta como confirmación física. Sirve cuando la persona no puede
// verificar mirando: cargando el camión, con guantes, en el depósito.
//
// Regla para no gastarlo: se usa cuando confirma algo que no se puede
// comprobar de un vistazo, o cuando algo salió mal. No en cada guardado ni en
// cada navegación — si vibra todo, deja de significar algo.
//
// En iPhone no existe la Vibration API (Safari nunca la implementó), así que
// esto es una mejora para Android que en iOS simplemente no hace nada.
//
// Si alguien reporta que "no vibra": lo primero a descartar es el modo No
// Molestar del teléfono. Lo silencia por completo y navigator.vibrate sigue
// devolviendo true, así que desde el código es indistinguible de haber
// vibrado. Nos costó cuatro despliegues aprenderlo.
function vibrar(patron) {
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
      navigator.vibrate(patron);
    }
  } catch {
    // Algunos navegadores tiran si la página nunca recibió un gesto del usuario.
  }
}

// Pulsos muy cortos a propósito: son confirmaciones, no alarmas. Se probaron
// 25/15 y quedaban pesados; 12/6 todavía se sentían de más.
const haptic = {
  // Confirmación de que algo quedó marcado. Corto y seco.
  tick: () => vibrar(8),
  // Se deshizo la marca: más suave, para que no se confunda con el tilde.
  untick: () => vibrar(5),
  // Algo salió mal. Doble pulso: lo que lo distingue es el ritmo, no la fuerza.
  warn: () => vibrar([12, 50, 12]),
};

export default haptic;
